import usePortfolio from "../hooks/PortfolioProvider"
import { usePath } from "../libs/path/PathProvider"
import Prices from "../models/Prices"
import useDateRangeFilter from "./DateRangeFilterProvider"
import PortUtils from "./PortUtils"

export default function useCashSummary(){
    const {query} = usePath()
    const {portfolio} = usePortfolio()
    const {end} = useDateRangeFilter()

    const account = PortUtils.getFilter(query).account
    let cash_ca_holding = portfolio.cash(0).filterByAccount(account)
    let cash_us_holding = portfolio.cash(1).filterByAccount(account)

    const endDate = end;
    let endTime = 0
    if (!PortUtils.dateEq(endDate, new Date())) {
        endTime = endDate.getTime()
        cash_ca_holding = PortUtils.trimTransactions(cash_ca_holding, endDate.getTime())
        cash_us_holding = PortUtils.trimTransactions(cash_us_holding, endDate.getTime())
    }

    const cash_ca =  cash_ca_holding.holdingValue
    const cash_us =  cash_us_holding.holdingValue
    const save_ca = portfolio.termQuantity("SAVE", 0, "", account, endTime)
    const save_us = portfolio.termQuantity("SAVE", 1, "", account, endTime)
    const bond_ca = portfolio.termQuantity("BOND", 0, "", account, endTime)
    const bond_us = portfolio.termQuantity("BOND", 1, "", account, endTime)
    const gic_ca = portfolio.termQuantity("GIC", 0, "", account, endTime)
    const gic_us = portfolio.termQuantity("GIC", 1, "", account, endTime)
    const equity_ca = portfolio.holdingValue(0, "", account, true, endTime)
    const equity_us = portfolio.holdingValue(1, "", account, true, endTime)
    const deposit_ca = portfolio.getDeposit(account, 0, endTime)
    const deposit_us = portfolio.getDeposit(account, 1, endTime)
    const total_ca = cash_ca+save_ca+bond_ca+gic_ca+equity_ca
    const total_us = cash_us+save_us+bond_us+gic_us+equity_us
    const gain_ca = total_ca - deposit_ca
    const gain_us = total_us - deposit_us
    const performance_ca = !PortUtils.isZero(deposit_ca) ? gain_ca/deposit_ca*100 : 0
    const performance_us = !PortUtils.isZero(deposit_us) ? gain_us/deposit_us*100 : 0
    return { cash_ca_holding, cash_us_holding, cash_ca, cash_us, save_ca, save_us, bond_ca, bond_us, gic_ca, gic_us, equity_ca, equity_us, 
        deposit_ca, deposit_us, total_ca, total_us, gain_ca, gain_us, performance_ca, performance_us, usd2cad:Prices.i.USD2CAD }
}